import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import Sidebar from "./Sidebar.jsx";
import ThemeToggle from "./ThemeToggle.jsx";

export default function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { pathname } = useLocation();

  // Scroll to top + close mobile sidebar on route change
  useEffect(() => {
    window.scrollTo(0, 0);
    setSidebarOpen(false);
  }, [pathname]);

  return (
    <div className="min-h-screen flex bg-bg text-ink">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="flex-1 md:ml-[280px] min-h-screen flex flex-col">
        {/* Mobile-only top bar */}
        <header className="md:hidden sticky top-0 z-20 border-b border-border bg-bg/85 backdrop-blur">
          <div className="flex items-center justify-between px-4 py-3">
            <button
              onClick={() => setSidebarOpen(true)}
              className="p-2 -ml-2 rounded-lg text-ink hover:bg-border/40 transition-colors"
              aria-label="Abrir menu"
            >
              <Menu size={20} />
            </button>
            <Link
              to="/"
              className="font-serif font-medium text-lg no-underline text-ink tracking-tight"
            >
              Aqui no{" "}
              <span className="italic font-semibold text-accent">Japão</span>
            </Link>
            <ThemeToggle compact />
          </div>
        </header>

        <main className="flex-1 max-w-content mx-auto w-full px-5 py-10 md:py-16">
          {children}
        </main>

        <Footer />
      </div>
    </div>
  );
}

function Footer() {
  return (
    <footer className="border-t border-border mt-16">
      <div className="max-w-content mx-auto px-5 py-10 grid md:grid-cols-3 gap-8 text-sm">
        <div>
          <div className="font-serif font-medium text-lg mb-2">
            Aqui no <span className="italic font-semibold text-accent">Japão</span>
          </div>
          <p className="text-ink-soft leading-relaxed">
            Ferramentas honestas para brasileiros no Japão. Feito em Maizuru,
            por alguém que também faz contas no fim do mês.
          </p>
        </div>
        <div>
          <div className="font-semibold text-ink mb-3">Navegação</div>
          <ul className="space-y-2 text-ink-soft">
            <li>
              <Link to="/calculadoras" className="hover:text-ink no-underline">
                Calculadoras
              </Link>
            </li>
            <li>
              <Link to="/guias" className="hover:text-ink no-underline">
                Guias
              </Link>
            </li>
            <li>
              <Link to="/sobre" className="hover:text-ink no-underline">
                Sobre
              </Link>
            </li>
            <li>
              <Link to="/privacidade" className="hover:text-ink no-underline">
                Privacidade
              </Link>
            </li>
            <li>
              <Link to="/termos" className="hover:text-ink no-underline">
                Termos
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <div className="font-semibold text-ink mb-3">Aviso</div>
          <p className="text-ink-soft leading-relaxed">
            Este site oferece estimativas educacionais. Para decisões importantes
            (impostos, aposentadoria, vistos), consulte um profissional
            qualificado ou a autoridade competente.
          </p>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="max-w-content mx-auto px-5 py-5 flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-ink-soft">
          <span>
            © {new Date().getFullYear()} aquinojapao ·{" "}
            <span className="font-serif italic">honestidade antes de otimismo</span>
          </span>
          <span className="font-mono">v0.6.0 · beta</span>
        </div>
      </div>
    </footer>
  );
}
